import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx, css } from '@emotion/react';
import { useState, lazy, Suspense, useRef } from 'react';
import { AkForm, FormContext, useForm } from '../form';
import { useNativeActionButtons } from '../utils/useNativeActionButton';
import { useNativeButton } from '../button';
var AkModalDialog = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.modal-dialog' */
  '@atlaskit/modal-dialog');
});
var AKModalHeader = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.modal-dialog/modal-header' */
  '@atlaskit/modal-dialog/modal-header');
});
var AKModalTitle = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.modal-dialog/modal-title' */
  '@atlaskit/modal-dialog/modal-title');
});
var AKModalBody = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.modal-dialog/modal-body' */
  '@atlaskit/modal-dialog/modal-body');
});
var AKModalFooter = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.modal-dialog/modal-footer' */
  '@atlaskit/modal-dialog/modal-footer');
});
var AKButton = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.button/loading-button' */
  '@atlaskit/button/loading-button');
});
function useModalDialog(_ref) {
  var _formForgeDoc$props;
  var forgeDoc = _ref.forgeDoc,
    dispatch = _ref.dispatch,
    render = _ref.render;
  var _ref2 = forgeDoc.props || {},
    appearance = _ref2.appearance,
    header = _ref2.header,
    onClose = _ref2.onClose,
    _ref2$closeButtonText = _ref2.closeButtonText,
    closeButtonText = _ref2$closeButtonText === void 0 ? 'Cancel' : _ref2$closeButtonText,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? 'medium' : _ref2$width,
    onSubmitSuccess = _ref2.onSubmitSuccess;
  var formForgeDoc = forgeDoc.children.length === 1 && forgeDoc.children[0].type === 'Form' ? forgeDoc.children[0] : undefined;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isClosing = _useState4[0],
    setIsClosing = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    formValues = _useState6[0],
    setFormValues = _useState6[1];
  var setFormValue = function setFormValue(name, value) {
    setFormValues(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, name, value));
    });
  };
  var _useForm = useForm({
      // This is awkward because we only use values if formForgeDoc exists
      // I want to conditionally call this hook but I can't
      forgeDoc: formForgeDoc || {
        type: 'Form',
        children: []
      },
      dispatch: dispatch,
      render: render
    }),
    children = _useForm.children,
    akFormProps = _useForm.akFormProps,
    htmlFormProps = _useForm.htmlFormProps,
    akFormSubmitButtonProps = _useForm.akSubmitButtonProps;
  var akFormPropsWithOnSubmit = _objectSpread(_objectSpread({}, akFormProps), {}, {
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setIsSubmitting(true);
              _context.prev = 1;
              _context.next = 4;
              return akFormProps.onSubmit.apply(akFormProps, _args);
            case 4:
              if (!onSubmitSuccess) {
                _context.next = 7;
                break;
              }
              _context.next = 7;
              return onSubmitSuccess();
            case 7:
              _context.prev = 7;
              setIsSubmitting(false);
              return _context.finish(7);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1,, 7, 10]]);
      }));
      function onSubmit() {
        return _onSubmit.apply(this, arguments);
      }
      return onSubmit;
    }()
  });
  var formId = useRef("modal-form-id-".concat(Date.now()));
  var akSubmitButtonProps = _objectSpread(_objectSpread({}, akFormSubmitButtonProps), {}, {
    appearance: appearance || 'primary',
    isLoading: isSubmitting,
    form: formId.current
  });
  var handleClose = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setIsClosing(true);
            _context2.prev = 1;
            _context2.next = 4;
            return onClose();
          case 4:
            _context2.prev = 4;
            setIsClosing(false);
            return _context2.finish(4);
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1,, 4, 7]]);
    }));
    return function handleClose() {
      return _ref3.apply(this, arguments);
    };
  }();
  var actions = (formForgeDoc === null || formForgeDoc === void 0 || (_formForgeDoc$props = formForgeDoc.props) === null || _formForgeDoc$props === void 0 ? void 0 : _formForgeDoc$props.actionButtons) || [];
  var _useNativeActionButto = useNativeActionButtons({
      forgeDoc: actions,
      dispatch: dispatch,
      render: render
    }),
    akActionButtonProps = _useNativeActionButto.akActionButtonProps;
  var _useNativeButton = useNativeButton({
      forgeDoc: {
        type: 'Button',
        props: {
          appearance: 'subtle',
          onClick: onClose
        },
        children: [{
          type: 'String',
          children: [],
          props: {
            text: closeButtonText
          }
        }]
      },
      dispatch: dispatch,
      render: render
    }),
    closeButtonProps = _useNativeButton.akButtonProps;
  var akCloseButtonProps = _objectSpread(_objectSpread({}, closeButtonProps), {}, {
    isLoading: isClosing || closeButtonProps.isLoading
  });
  var akFormPropsWithOnSubmitKey = akFormPropsWithOnSubmit.key,
    akFormPropsWithOnSubmitOnSubmit = akFormPropsWithOnSubmit.onSubmit;
  return {
    akModalDialogProps: {
      onClose: handleClose,
      width: width
    },
    akModalTitleProps: {
      appearance: appearance,
      children: header
    },
    akModalBodyProps: {
      children: formForgeDoc ? jsx(AkForm, {
        key: akFormPropsWithOnSubmitKey,
        onSubmit: akFormPropsWithOnSubmitOnSubmit
      }, function (_ref4) {
        var formProps = _ref4.formProps;
        var ref = formProps.ref,
          onSubmit = formProps.onSubmit,
          onKeyDown = formProps.onKeyDown;
        // @ts-ignore
        var dataTestId = htmlFormProps['data-testid'],
          className = htmlFormProps.className;
        return jsx("form", {
          ref: ref,
          onSubmit: onSubmit,
          onKeyDown: onKeyDown,
          "data-testid": dataTestId
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
          ,
          className: className,
          id: formId.current
        }, jsx(FormContext.Provider, {
          value: {
            formValues: formValues,
            setFormValue: setFormValue
          }
        }, children));
      }) : jsx("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: css({
          display: 'inherit',
          width: 'inherit',
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
          '> *:not(:first-child)': {
            marginTop: "var(--ds-space-150, 12px)",
            width: 'inherit'
          }
        })
      }, forgeDoc.children.map(render))
    },
    actions: formForgeDoc ? [].concat(_toConsumableArray(akActionButtonProps), [akCloseButtonProps, akSubmitButtonProps]) : [akCloseButtonProps]
  };
}
export function ModalDialog(props) {
  var _useModalDialog = useModalDialog(props),
    akModalDialogProps = _useModalDialog.akModalDialogProps,
    akModalTitleProps = _useModalDialog.akModalTitleProps,
    akModalBodyProps = _useModalDialog.akModalBodyProps,
    actions = _useModalDialog.actions;
  var onClose = akModalDialogProps.onClose,
    width = akModalDialogProps.width;
  var appearance = akModalTitleProps.appearance,
    akModalTitleChildren = akModalTitleProps.children;
  var akModalBodyChildren = akModalBodyProps.children;
  return jsx(Suspense, {
    fallback: null
  }, jsx(AkModalDialog, {
    onClose: onClose,
    width: width
  }, jsx(AKModalHeader, null, jsx(AKModalTitle, {
    appearance: appearance
  }, akModalTitleChildren)), jsx(AKModalBody, null, akModalBodyChildren), jsx(AKModalFooter, null, actions.map(function (akButtonProps) {
    var shouldFitContainer = akButtonProps.shouldFitContainer,
      iconBefore = akButtonProps.iconBefore,
      iconAfter = akButtonProps.iconAfter,
      isLoading = akButtonProps.isLoading,
      isDisabled = akButtonProps.isDisabled,
      appearance = akButtonProps.appearance,
      onClick = akButtonProps.onClick,
      children = akButtonProps.children,
      type = akButtonProps.type,
      form = akButtonProps.form;
    return jsx(AKButton, {
      shouldFitContainer: shouldFitContainer,
      iconBefore: iconBefore,
      iconAfter: iconAfter,
      isLoading: isLoading,
      isDisabled: isDisabled,
      appearance: appearance,
      onClick: onClick,
      type: type,
      form: form
    }, children);
  }))));
}